import { useContext, useCallback } from 'react'

import ContentModalContext from '../../../ContentModalProvider/Context'
import { FIELD_NAMES } from '../../../components/constants'

export const updateTimeWithDate = (date: Date | string | null, time: Date | string | null) => {
  if (date && time) {
    if (typeof date === 'string') {
      date = new Date(date)
    }
    if (typeof time === 'string') {
      time = new Date(time)
    }
    const dateInTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      time.getHours(),
      time.getMinutes(),
      time.getSeconds(),
    )
    return dateInTime
  }
  return time
}

interface IUpdatesObject {
  [key: string]: any
}

/**
 * Updates the date field and the time fields using the date field if they've been set
 * @returns function to update the date field
 */
export const useOnUpdateDate = () => {
  const { item, onUpdateFields } = useContext(ContentModalContext)

  const startTime = item[FIELD_NAMES.START_TIME]
  const endTime = item[FIELD_NAMES.END_TIME]
  const recurring = item[FIELD_NAMES.IS_RECURRING]

  const onUpdateDate = useCallback(
    (date: Date | null): void => {
      const updates: IUpdatesObject = {
        [FIELD_NAMES.DATE]: date,
      }
      if (!recurring) {
        if (startTime) {
          updates[FIELD_NAMES.START_TIME] = updateTimeWithDate(date, startTime)
        }
        if (endTime) {
          updates[FIELD_NAMES.END_TIME] = updateTimeWithDate(date, endTime)
        }
      }
      onUpdateFields(updates)
    },
    [onUpdateFields, recurring, startTime, endTime],
  )

  return onUpdateDate
}

/**
 * Updates the time field using the date field
 * @param fieldName of time field to update
 * @returns function to update that time field
 */
export const useOnUpdateTime = (fieldName: string) => {
  const { item, onUpdateField } = useContext(ContentModalContext)

  const date = item[FIELD_NAMES.DATE]

  const onUpdateTime = useCallback(
    (time: Date | null): void => {
      onUpdateField(fieldName, updateTimeWithDate(date, time))
    },
    [fieldName, onUpdateField, date],
  )

  return onUpdateTime
}
